export { ModalContainerComponent } from './modal-container.component';
export { ModalBackdropComponent, ModalBackdropOptions } from './modal-backdrop.component';
export { ModalOptions, BsModalRef } from './modal-options.class';
export { ModalDirective } from './modal.component';
export { ModalModule } from './modal.module';
export { BsModalService } from './bs-modal.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/modal/index.js
// module id = 389
// module chunks = 3